
import { compare_version } from './version'

export default function addCalendar(title, description, reminderTimeMS, durationMS, previousTimeMinutes) {
    return new Promise((resolve, reject) => {

        if (!gact.is_app) {
            reject('非芒果TV APP');
            return;
        }

        if (gact.is_ipad) { //暂未排期
            reject('APP版本不支持');
        }

        if (gact.is_iphone && compare_version('<', '6.4.5')) {
            reject('APP版本不支持');
        }

        if (gact.is_android && compare_version('<', '6.5.0_0_3')) {
            reject('APP版本不支持');
        }

        const param = {
            title: title,
            description: description,
            reminderTimeMS: reminderTimeMS , //预约的时间，时间戳，毫秒13位
            durationMS: durationMS, //70000, //持续时长
            previousTimeMinutes: previousTimeMinutes // 1 //提前多少分钟提醒
        };
        console.log('addCalendar', param);
        MgtvApi.callhandler('addCalendarEvent', param, function (data) { //注意返回类型，是json字符串
            console.log(data, typeof data)
            const ret = typeof data === 'string' ? JSON.parse(data) : data;
            //ios  是object, 安卓是string
            if (ret.code == 200) { //响应正常
                //aphone中
                if(typeof ret.data === 'string'){
                    ret.data = JSON.parse(ret.data)
                }
                var resultCode = ret.data.resultCode;
                if (resultCode != 1) {
                    reject('添加失败，错误码:' + resultCode);

                }
                resolve('添加日历成功');
            }
        })
    })

}